import { Svg } from "../Pages/Components/Utils/Svg";
import { Icons } from "./Utils/Icons";


export class CloseIcon extends Svg
{
    constructor()
    {
        super(Icons.Close);
    }
}
